// @ts-strict-ignore
import { ProjectVO } from '@project/model/vo/project.vo';
import { ProjectUtils } from '@project/components/project/util/project-utils';
import { ArticleUtils } from '@article/util/article-utils';
import { Injectable } from '@angular/core';
import { ProjectService } from '../../import-export/service/project.service';
import { ProjectType } from '../../../model/project-type';
import { IsProjectType } from '../../../model/is-project-type';

@Injectable({ providedIn:'root' })
export class ProjectTypeValidator {

  constructor(private projectService: ProjectService) { }

  public validateProjectType(project: ProjectVO): void {
    const projectTypeByRailArticle = this.getCorrectedMountingRailProjectType(project);
    if (projectTypeByRailArticle) {
      project.projectType = projectTypeByRailArticle;
    }
  }

  /**
   * Checks whether the project type of MOUNTING_RAIL has to be changed.
   * Can be used in case when specific rail article (like free mounting, speedway)
   * is used in genericly typed rail project, so that appropriate specific project type should be applied.
   *
   * @param project the project which type should be checked
   *
   * @return appropriate project type determined by rail-article in case when type of given mounting-rail project has to be changed,
   * otherwise null
   */
  private getCorrectedMountingRailProjectType(project: ProjectVO): ProjectType {
    if (!IsProjectType.visibleMountingRail(project) || ProjectUtils.isEmptyProject(project)) {
      return null;
    }

    for(const article of this.projectService.getArticles(project)) {
      const isMountingRailDetermined: boolean = ArticleUtils.isMountingRail(article);
      // we don't need to check article-id if we know that given article is not mounting-rail beforehand
      if (article && !isMountingRailDetermined) {
        continue;
      }
      const projectTypeByRailArticle = ProjectUtils.getProjectTypeByMountingRailArticleId(article.identity, false);
      // in case we determined that article is definitely mounting rail, then we don't need to check further articles
      if (isMountingRailDetermined || projectTypeByRailArticle) {
        return projectTypeByRailArticle;
      }
    }
    return null;
  }
}
